import BaseNormalizer from "./BaseNormalizer";

// please keep in alphabetical order
const startupsNormalizer = Object.create(BaseNormalizer).init([
  "city",
  "companyBackground",
  "contactJob",
  "contactMail",
  "contactName",
  "contactPhone",
  "countryCode",
  "id",
  "logo",
  "mainProductCategory",
  "name",
  "postalCode",
  "startupAccount.email",
  "startupAccount.firstName",
  "startupAccount.lastName",
  "startupAccount.phone",
  "startupAccount.phoneCountryCode",
  "startupAccount.salutation",
  "street",
  "subscribedNewsletter",
  "teamBackground",
  "teamImage",
  "tradeRegisterNo",
  "website",
]);

export default startupsNormalizer;
